"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://sparta-ux.com/oui-base/tests/pagination.html
 */
var React = require("react");
var index_1 = require("../index");
var util_1 = require("../utils/util");
var Messages = require("../codegen/Messages");
var warning_1 = require("../utils/warning");
var PageDirection;
(function (PageDirection) {
    PageDirection["prev"] = "previous";
    PageDirection["next"] = "next";
})(PageDirection || (PageDirection = {}));
/**
 * OUI pagination component.
 *
 * @oui-component Pagination
 */
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getArrowElement = function (direction) {
            var _a;
            // generate data attribute for pagination icon,
            // note that button icon visually is too subtle and small, so use UIKit style icon for now
            var spanProps = (_a = {},
                _a["data-oui-pagination-" + direction] = "",
                _a);
            return React.createElement("span", __assign({}, spanProps));
        };
        // generate prev or next list items
        _this.generatePageArrow = function (direction, onClick, currentPage, pageCount) {
            var _a = _this.props, id = _a.id, testId = _a.testId, previousHiddenText = _a.previousHiddenText, nextHiddenText = _a.nextHiddenText;
            // deprecate in v5
            var liProps = __assign({}, (id && { id: id + "-" + direction }));
            var onClickWrapper = function () {
                onClick && onClick(currentPage);
            };
            var disabled = onClick === undefined ||
                (direction === PageDirection.prev && currentPage === 0) ||
                (direction === PageDirection.next && currentPage === pageCount - 1);
            // either use consumer specified text ot intelligent defaults for screen readers
            var assistiveText = direction === PageDirection.prev
                ? previousHiddenText ||
                    (disabled
                        ? Messages.Pagination.previousPage()
                        : Messages.Pagination.backToPage(currentPage))
                : nextHiddenText ||
                    (disabled
                        ? Messages.Pagination.nextPage()
                        : Messages.Pagination.nextToPage(currentPage + 2));
            var buttonProps = {
                disabled: disabled,
                buttonStyle: index_1.ButtonStyle.Link,
                label: assistiveText,
                onClick: onClickWrapper,
                testId: testId && testId + "-" + direction,
                title: assistiveText
            };
            return (React.createElement("li", __assign({}, liProps),
                React.createElement(index_1.Button, __assign({}, buttonProps), _this.getArrowElement(direction))));
        };
        _this.normalizePageIndices = function (currentPage, pageCount) {
            var normalizedCurrentPage = currentPage;
            var normalizedPageCount = pageCount;
            // Validate pageCount and currentPage, changing them to something meaningful if necessary
            if (normalizedPageCount < 1) {
                // There has to be at least one page
                console.error("pageCount " + normalizedPageCount + " out of bounds, should be >= 1");
                normalizedPageCount = 1;
            }
            if (normalizedCurrentPage < 0) {
                // Current page cannot be a negative number
                console.error("currentPage " + normalizedCurrentPage + " out of bounds, should be >= 0");
                normalizedCurrentPage = 0;
            }
            else if (normalizedCurrentPage >= normalizedPageCount) {
                // Current page must be less than total pages
                console.error("currentPage " + normalizedCurrentPage + " out of bounds, should be < " + normalizedPageCount + " (pageCount)");
                normalizedCurrentPage = normalizedPageCount - 1;
            }
            return {
                normalizedCurrentPage: normalizedCurrentPage,
                normalizedPageCount: normalizedPageCount
            };
        };
        return _this;
    }
    Pagination.prototype.render = function () {
        var _a = this.props, id = _a.id, currentPage = _a.currentPage, pageCount = _a.pageCount, currentPageText = _a.currentPageText, pageCountText = _a.pageCountText, onPrevious = _a.onPrevious, onNext = _a.onNext, testId = _a.testId, rest = __rest(_a, ["id", "currentPage", "pageCount", "currentPageText", "pageCountText", "onPrevious", "onNext", "testId"]);
        // deprecate in v5, warn in v4
        warning_1.default(id !== undefined, "deprecation warning, passing `id` to pagination has been replaced with using `testId` this prop will be removed in next major version.");
        var _b = this.normalizePageIndices(currentPage, pageCount), normalizedCurrentPage = _b.normalizedCurrentPage, normalizedPageCount = _b.normalizedPageCount;
        var baseOneCurrentPage = normalizedCurrentPage + 1;
        var ulProps = __assign({ id: id }, rest, util_1.ariaProps(rest), { role: "navigation", "data-test-id": testId, className: "oui-pagination oui-float-right oui-margin-remove" });
        // location string displayed in between 2 arrows
        var locationText = normalizedPageCount
            ? (pageCountText &&
                pageCountText(normalizedCurrentPage, normalizedPageCount)) ||
                Messages.Pagination.pageLocation(baseOneCurrentPage, normalizedPageCount)
            : (currentPageText && currentPageText(normalizedCurrentPage)) ||
                Messages.Pagination.pageLabel(baseOneCurrentPage);
        // Don't allow these props to be passed to the DOM element
        delete ulProps.previousHiddenText;
        delete ulProps.nextHiddenText;
        return (React.createElement("ul", __assign({}, ulProps),
            this.generatePageArrow(PageDirection.prev, onPrevious, normalizedCurrentPage, normalizedPageCount),
            React.createElement("li", { className: "oui-active", id: id && id + "-text" },
                React.createElement("span", null, locationText)),
            this.generatePageArrow(PageDirection.next, onNext, normalizedCurrentPage, normalizedPageCount)));
    };
    return Pagination;
}(React.Component));
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map